export default "__VITE_ASSET__BYXRGbNS__"